"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearObjectFromProps = void 0;
require("../../core");
const clearObjectFromProps = (obj, props = []) => Object.keys(obj).reduce((object, key) => {
    if (props.indexOf(key) === -1) {
        object[key] = obj[key];
    }
    return object;
}, {});
exports.clearObjectFromProps = clearObjectFromProps;
//# sourceMappingURL=clearObjectFromProps.js.map